import {
  fetchPostOpenBankingShareableLink,
  PostOpenBankingShareableLinkResponse,
} from '@iwoca/lapi-client/edge';
import { useMutation } from '@tanstack/react-query';

export function usePostOpenBankingShareableLink() {
  const { mutateAsync, isPending, isError, data } = useMutation<
    PostOpenBankingShareableLinkResponse,
    Error,
    { stateKey: string }
  >({
    mutationFn: ({ stateKey }) =>
      fetchPostOpenBankingShareableLink({ stateKey }),
  });

  return { mutateAsync, isPending, isError, data: data?.data };
}
